import React, { useEffect, useMemo, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";

import FinancialYearDropdown from "../../home/financial-year-dropdown";
import { vendorList } from "../../purchase-order/po-filters/apis";
import { storeRegionList } from "./apis";

import "./index.scss";

const DashboardFilters = ({ filters, setFilters, isVendorBranch }) => {
  const [storeList, setStoreList] = useState([]);
  const [storeLoadState, setStoreLoadState] = useState("loading");
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendorLoadState, setVendorLoadState] = useState("loading");

  useEffect(() => {
    storeRegionList((list) => {
      setStoreList(list);
      setStoreLoadState("loaded");
    });

    if (!isVendorBranch) {
      vendorList((list) => {
        setVendorOptions(list);
        setVendorLoadState("loaded");
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVendorBranch]);

  const regionOptions = useMemo(() => {
    const regions = [...new Set(storeList.map((store) => store.region).filter(Boolean))].sort();
    return regions.map((region) => ({ label: region, value: region }));
  }, [storeList]);

  const storeOptions = useMemo(
    () =>
      filters.region
        ? storeList.filter((store) => store.region === filters.region)
        : storeList,
    [storeList, filters.region]
  );

  const handleRegionChange = (event, option) => {
    const newRegion = option?.value;
    setFilters((prev) => {
      const currentStore = storeList.find((store) => store.value === prev.site);
      const siteStillValid = !newRegion || currentStore?.region === newRegion;
      return { ...prev, region: newRegion, site: siteStillValid ? prev.site : undefined };
    });
  };

  const handleStoreChange = (event, option) => {
    const matched = storeList.find((store) => store.value === option?.value);
    setFilters((prev) => ({
      ...prev,
      site: option?.value,
      region: matched ? matched.region : prev.region,
    }));
  };

  const handleVendorChange = (event, option) => {
    setFilters((prev) => ({ ...prev, vendorCode: option?.value }));
  };

  return (
    <Box className="finance-v2-dashboard-filters-row">
      {!isVendorBranch && <FinancialYearDropdown filters={filters} setFilters={setFilters} />}

      <Autocomplete
        className="dashboard-filters-control"
        loading={storeLoadState === "loading"}
        value={filters.site ? storeOptions.find((store) => store.value === filters.site) || null : null}
        onChange={handleStoreChange}
        options={storeOptions}
        renderInput={(params) => (
          <TextField {...params} size="small" label="Store" sx={{ minWidth: 220 }} />
        )}
      />

      <Autocomplete
        className="dashboard-filters-control"
        loading={storeLoadState === "loading"}
        value={filters.region ? regionOptions.find((region) => region.value === filters.region) || null : null}
        onChange={handleRegionChange}
        options={regionOptions}
        renderInput={(params) => (
          <TextField {...params} size="small" label="Region" sx={{ minWidth: 180 }} />
        )}
      />

      {!isVendorBranch && (
        <Autocomplete
          className="dashboard-filters-control"
          loading={vendorLoadState === "loading"}
          value={
            filters.vendorCode
              ? vendorOptions.find((vendor) => vendor.value === filters.vendorCode) || null
              : null
          }
          onChange={handleVendorChange}
          options={vendorOptions}
          renderInput={(params) => (
            <TextField {...params} size="small" label="Vendor" sx={{ minWidth: 220 }} />
          )}
        />
      )}
    </Box>
  );
};

export default DashboardFilters;
